import { Content } from "@/ui/Content";
import * as additionalComponents from "@/components/AwardsPage";
import { router } from "@/router";
import { stripTags } from "@/functions/stripTags";
import { getGlobal } from "@/functions/getGlobal";
import { insights_helper } from "@/helpers/insights_helper";
import sourceflowEnums from "@/sourceflow.enums";
import { toInsightCardItems } from "@/functions/toInsightCardItems";

export default function Page({ content }) {
  return (
    <>
      <Content items={content} additionalComponents={additionalComponents} />
    </>
  );
}

export async function getStaticProps({}) {
  const global = getGlobal();
  const insights = toInsightCardItems(insights_helper.filter((i) => ("tags" in i ? i?.tags?.includes("Awards") : false)));

  const routerProp = router["about.awards"];
  const titleKey = "page.awards.banner.title";

  return {
    props: {
      meta: {
        en: {
          title: stripTags(global[`${titleKey}.en`]),
          canonical: `${sourceflowEnums.config.baseUrl}${routerProp["en"]}`,
        },
      },
      router: routerProp,
      content: [
        { component: "AwardsPageBannerSection", props: { className: "" } },
        { component: "AwardsPageTextSection", props: { className: "py-4 pt-md-5 pb-md-0" } },
        { component: "AwardsPageFeedSection", props: { className: "py-4 pt-md-0 pb-md-5" } },
        {
          component: "InsightsSection",
          props: {
            className: "py-4 py-md-5",
            title: { path: "page.awards.insights.title" },
            items: insights,
          },
        },
        { component: "AwardsPageImageSection", props: { className: "py-4 py-md-5" } },
      ],
    },
  };
}
